import { GlobalUser } from 'services/user';

export const resolveUserEditModalTitle = (selectedUser: GlobalUser) => {
  const email = selectedUser.email ? `, ${selectedUser.email}` : '';

  return `${selectedUser.nameFirst || ''} ${
    selectedUser.nameLast || ''
  }${email}`;
};
